import React from 'react';
import Formsy from 'formsy-react';
import FormsySimpleInput from '../../form/FormsySimpleInput';
import withOnboarding from '../withOnboarding';
import ChefLocationList from '../../chef/ChefLocationList';
import { stringfyServerErrors } from '../../../helpers/util';
import { chefAPI } from '../../../InterfaceAPI/chefAPI';

class ChefLocations extends React.Component {
  state = {
    serviceDistricts: [],
    availableServiceDistricts: []
  };

  render() {
    return (
      <div className="on-boarding__step on-boarding_step--chef">
        <div className="on-boarding__wrap on-boarding__wrap--chef-locations">
          <h1 className="on-boarding__h1">
            Which locations would you like to serve?
          </h1>
          <p className="on-boarding__p">Please select all that apply.</p>

          <ChefLocationList
            serviceDistricts={this.state.serviceDistricts}
            availableServiceDistricts={this.state.availableServiceDistricts}
            toggleDistrict={this.toggleDistrict}
            toggleGroup={this.toggleGroup}
            itemClass="chef-location__sub-district chef-location__sub-district--half"
          />

          {/*other_service_districts*/}

          <Formsy
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
          >
            <FormsySimpleInput
              type="hidden"
              name="total_districts"
              value={this.state.serviceDistricts.length}
              validations="isGreaterThan:0"
            />
            <FormsySimpleInput
              type="hidden"
              name="all_forms_valid"
              value={this.props.actions.isValid('submit')}
              validations="isTrue"
            />
            <input
              ref={this.props.actions.assignTrigger}
              type="submit"
              hidden
            />
          </Formsy>
        </div>
      </div>
    );
  }
  // http://localhost:5000/chefs/auth/confirmation?config=default&amp;confirmation_token=ZStn6YSN3_qZ6G2yacsS&amp;redirect_url=http://localhost:3000/new-chef/start
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ChefOnboarding component
  handleSubmit = (formData, data, errors) => {
    const { serviceDistricts: service_district_subsections } = this.state;
    // update chef
    const updatedChef = { service_district_subsections };
    this.props.updateChef(updatedChef);
    this.props.actions.markComplete(this.props.step);
  };

  reset = () => {
    this.props.updateChef({ service_district_subsections: [] });
  };

  toggleDistrict = district => {
    const districts = [...this.state.serviceDistricts];
    const index = districts.findIndex(sd => sd.id === district.id);

    let serviceDistricts = [];
    if (index >= 0) {
      // delete
      serviceDistricts = [
        ...districts.slice(0, index),
        ...districts.slice(index + 1, districts.length)
      ];
    } else {
      // add
      serviceDistricts = [...districts, district];
    }
    this.setState({ serviceDistricts });
  };

  toggleGroup = group => {
    const groupIds = group.service_district_subsections.map(d => d.id);
    const selectedIds = this.state.serviceDistricts.map(d => d.id);
    const doesContainAll = groupIds.every(id => selectedIds.includes(id));
    let serviceDistricts = [];

    if (doesContainAll) {
      // delete
      serviceDistricts = [
        ...this.state.serviceDistricts.filter(d => !groupIds.includes(d.id))
      ];
    } else {
      // add
      serviceDistricts = [
        ...this.state.serviceDistricts.filter(d => !groupIds.includes(d.id)),
        ...group.service_district_subsections
      ];
    }

    this.setState({ serviceDistricts });
  };

  componentDidMount() {
    const reset = this.props.resets.includes(this.props.step);

    if (reset) this.reset();

    this.deriveState();

    chefAPI
      .getServiceDistricts()
      .then(({ service_districts: availableServiceDistricts }) =>
        this.setState({ availableServiceDistricts })
      )
      .catch(err =>
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        })
      );
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (
      this.props.chef.service_district_subsections !==
      prevProps.chef.service_district_subsections
    )
      this.deriveState();
  }

  deriveState() {
    const {
      service_district_subsections: serviceDistricts = []
    } = this.props.chef;
    this.setState({ serviceDistricts });
  }
}

export default withOnboarding(ChefLocations);



// WEBPACK FOOTER //
// ./src/components/onboarding/chef/ChefLocations.js